import MutatorFactory from '@/util/import/MutatorFactory'
import { IEntryExported } from '@/types/entry'

MutatorFactory.register('vpx', (data: string): IEntryExported[] => JSON.parse(data))
